/* eslint-disable no-console */

let requestPromises = {}

const deviceCardFilter = (identityId) => {
  return (card) => {
    if(!card.isOutdated) {
      for (let signature of card.signatures) {
        if (signature.extraFields && signature.extraFields.identityId === identityId) {
          return true
        }
      }
    }
    return false
  }
}


class E2EECardCache {

  constructor() {
    this.memoryCache = {}
  }

  invalidateCard(identityId) {
    delete this.memoryCache[identityId]
    if(localStorage) {
      localStorage.removeItem(`senderCard.${identityId}`)
    }
  }

  // Returns the resolved Virgil card, or throws the underlying Virgil error
  // (e.g. UsersNotFoundError, UsersFoundWithMultipleCardsError, or a transient
  // auth/network failure). We intentionally no longer swallow failures into a
  // `false` value — doing so erased the cause and led `decryptImage` to hand a
  // boolean to Virgil, which surfaced as a misleading "duplicate card" error.
  _loadCardFromApi(e2eeHelper, cardFilter) {
    return e2eeHelper.eThree.findUsersWithCardFilter(
      e2eeHelper.virgilAccountIdentityId,
      cardFilter
    )
  }

  async getSendersCard(e2eeHelper, identityId) {
    console.log(`getSendersCard looking under ${e2eeHelper.virgilAccountIdentityId} for ${identityId}`)

    // Serve a previously cached successful lookup.
    if(this.memoryCache[identityId]) {
      return this.memoryCache[identityId]
    }

    // De-dupe concurrent lookups for the same identity so they share one request.
    let inFlight = requestPromises[identityId]
    if(!inFlight) {
      inFlight = this._loadCardFromApi(e2eeHelper, deviceCardFilter(identityId))
      requestPromises[identityId] = inFlight
    }

    try {
      let card = await inFlight
      // Only cache genuine cards. Never cache a failure: a transient
      // auth/network blip should be retried on the next decrypt, not pinned.
      if(card) {
        this.memoryCache[identityId] = card
      }
      return card
    } finally {
      if(requestPromises[identityId] === inFlight) {
        delete requestPromises[identityId]
      }
    }
  }

}

export default (new E2EECardCache())